// createDefaults — shell-side prefill builders for the "create new X"
// dialogs (smart-defaults quick wins, .claude/analysis/smart-defaults.md).
//
// PURE by design: the impure inputs are supplied by the caller — the
// localized word (from i18n `t`) and the names already in use (from the
// state read). These functions hold no i18n and read nothing; they only
// SHAPE a value the author can overwrite.

// The name a new project or material gets when the author leaves the name
// empty (PS-36, #211): `word` ("Untitled project", "New quiz") when nothing
// is called that, else
// "`word` n" with the lowest free n ≥ 2, the way Finder numbers copies.
// `taken` is every name in use among the author's projects (or materials),
// ARCHIVED ONES INCLUDED, so an archived "Untitled project 2" keeps its number. The name
// is decided at creation and stored, so renaming or removing a project
// later never shifts another's number; a freed number is reused.
//
// Complexity: O(k) time and space in the number of projects k — one pass
// to build a Set, then at most k + 1 constant-time lookups (k names can
// block at most k numbers).
export const numberedDefaultName = (
    taken: Iterable<string>,
    word: string,
): string => {
    const names = new Set(taken);
    if (!names.has(word)) return word;
    let n = 2;
    while (names.has(`${word} ${n}`)) n += 1;
    return `${word} ${n}`;
};
